import authProvider from "../authProvider";
import { Navigate } from "react-router-dom";
import { supabase } from "../utility/supabaseClient";
import { useState, useEffect } from "react";
import useSessionStore from "../stores/sessionStore";
import Spinner from "../components/Spinner.jsx";

const Unauthenticated = ({ children }) => {
  const [loading, setLoading] = useState(true);

  const user = useSessionStore((state) => state.user);
  const setUser = useSessionStore((state) => state.setUser);

  useEffect(() => {
    const initialize = async () => {
      const u = await authProvider.getIdentity();
      setUser(u);
      setLoading(false);
    };

    initialize();

    const { data: listener } = supabase.auth.onAuthStateChange((_event, newSession) => {
      if (!newSession) {
        setUser(null);
        return;
      }
      initialize();// this gets called at login time
    });
    return () => {
      listener.subscription.unsubscribe(); // unsubscribe supabase event listener on exit
    };
  }, [setUser]);

  if (loading) {
    return (
      <Spinner />
    );
  }

  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      {children}
    </>
  );
}

export default Unauthenticated;
